import { Flex, Text, Tooltip } from "@mantine/core";
import { ReactNode, useEffect, useRef, useState } from "react";

interface ResultDetailProps {
  label: string;
  value: ReactNode;
}

export const ResultDetail = ({ label, value }: ResultDetailProps) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [tooltipDisabled, setTooltipDisabled] = useState(true);

  useEffect(() => {
    if (textRef.current) {
      setTooltipDisabled(
        textRef.current.scrollWidth <= textRef.current.offsetWidth,
      );
    }
  }, [value]);

  return (
    <Flex align="baseline" className="gap-2.5">
      <Text className="whitespace-nowrap" size="sm">
        {label}:
      </Text>
      {typeof value === "string" ? (
        <Tooltip disabled={tooltipDisabled} label={value} multiline w={440}>
          <Text className="truncate" ref={textRef} size="sm">
            {value}
          </Text>
        </Tooltip>
      ) : (
        value
      )}
    </Flex>
  );
};
